module.exports = __webpack_public_path__ + "static/assets/007f4d26ef0c6bad6f435640d4c6703d.gif";